<template>
  <div class="">
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border mt-4" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else-if="dataLoaded" class="p-2">
      <h3>Compare Revisions of {{ postDetails.title }}</h3>
    </div>
    <div v-if="revisions.length == 0" class="text-danger h5 mx-2" style="font-weight: 500;"> This post hasn't been
      changed
      till now
    </div>
    <div class="bg-white rounded shadow pe-3 ps-3 pb-3 ">
      <div v-for="(revisionInfo, index) in revisions" :key="index">
        <div v-if="revisionInfo.changedColumns.length != 0" class="mt-4 p-2">
          <div class="d-flex flex-row align-items-end">
            <div class="h5">Edited on</div>
            <div class="h4 ms-2" style="font-weight: 500;color: brown;">{{ revisionInfo.action_date }}</div>
          </div>
          <div class="d-flex flex-row">
            <div class="mx-2 p-3 border rounded" style="background-color: rgb(251, 243, 243); width: 50%;">
              <div v-for="(changedColumnInfo, columnIndex) in revisionInfo.changedColumns" :key="columnIndex"
                   class="mb-1">
                <h3 style=" color: midnightblue; font-weight: 600;">{{ prettifyTitle(changedColumnInfo) }}</h3>
                <div v-if="revisionInfo[changedColumnInfo] != null && revisionInfo[changedColumnInfo] != ''">
                  <div
                      v-if="changedColumnInfo != 'body' && changedColumnInfo != 'body_en' && changedColumnInfo != 'active_yn'">
                    <div style="font-size: medium;"> {{ viewPublicYN(revisionInfo[changedColumnInfo]) }}
                    </div>
                  </div>
                  <div v-else-if="changedColumnInfo == 'active_yn'">
                    <div style="font-size: medium;"> {{ viewActiveYn(revisionInfo[changedColumnInfo]) }}
                    </div>
                  </div>
                  <div v-else v-html="revisionInfo[changedColumnInfo]">
                  </div>
                </div>
                <div v-else style="color: brown; font-weight: 500;">Empty</div>
              </div>
            </div>
            <div v-if="index - 1 >= 0" class="mx-2 p-3 border rounded"
                 style="background-color: rgb(234, 251, 238); width: 50%;">
              <div v-for="(changedColumnInfo, columnIndex) in revisionInfo.changedColumns" :key="columnIndex"
                   class="mb-1">
                <h3 style=" color: midnightblue; font-weight: 600;">{{ prettifyTitle(changedColumnInfo) }}</h3>
                <div
                    v-if="revisions[index - 1][changedColumnInfo] != null && revisions[index - 1][changedColumnInfo] != ''">
                  <div
                      v-if="changedColumnInfo != 'body' && changedColumnInfo != 'body_en' && changedColumnInfo != 'active_yn'">
                    <div style="font-size: medium;"> {{
                        viewPublicYN(revisions[index -
                        1][changedColumnInfo])
                      }}
                    </div>
                  </div>
                  <div v-else-if="changedColumnInfo == 'active_yn'">
                    <div style="font-size: medium;">{{
                        viewActiveYn(revisions[index -
                        1][changedColumnInfo])
                      }}
                    </div>
                  </div>
                  <div v-else v-html="revisions[index - 1][changedColumnInfo]">
                  </div>
                </div>
                <div v-else style="color: brown; font-weight: 500;">Removed</div>
              </div>
            </div>
            <div v-else class="mx-2 p-3 border rounded" style="background-color: rgb(234, 251, 238); width: 50%;">
              <div v-for="(changedColumnInfo, columnIndex) in revisionInfo.changedColumns" :key="columnIndex"
                   class="mb-1">
                <h3 style=" color: midnightblue; font-weight: 600;">{{ prettifyTitle(changedColumnInfo) }}</h3>

                <div v-if="postDetails[changedColumnInfo] != null && postDetails[changedColumnInfo] != ''">
                  <div
                      v-if="changedColumnInfo != 'body' && changedColumnInfo != 'body_en' && changedColumnInfo != 'active_yn'">
                    <div style="font-size: medium;"> {{ viewPublicYN(postDetails[changedColumnInfo]) }}
                    </div>
                  </div>
                  <div v-else-if="changedColumnInfo == 'active_yn'">
                    <div style="font-size: medium;"> {{ viewActiveYn(postDetails[changedColumnInfo]) }}
                    </div>
                  </div>
                  <div v-else v-html="postDetails[changedColumnInfo]">
                  </div>

                </div>
                <div v-else style="color: brown; font-weight: 500;">Removed</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import postService from '@/services/post.service';
import moment from 'moment';

export default {
  name: 'RevisionPage',
  data() {
    return {
      postId: null,
      postDetails: null,
      revisions: [],
      loading: false,
      dataLoaded: false,
    }
  },
  async created() {
    this.postId = this.$route.params.id;
    await this.getRevisions(this.postId);
    await this.getPostDetails(this.postId);
    this.dataLoaded = true;
  },
  methods: {
    async getPostDetails(post_id) {
      const response = await postService.getPostByElementId(post_id);
      if (response.data) {
        this.postDetails = response.data;
      }
    },
    async getRevisions(postId) {
      this.loading = true;
      const response = await postService.getPostRevisions(postId);
      this.loading = false;
      if (response.data) {
        this.revisions = response.data;
        this.revisions.forEach(element => {
          element.action_date = this.format_date(element.action_date);
          var splittedArray = element.updated_columns.replace(/ /g, '').split(",");
          splittedArray = splittedArray.filter(function (e) {
            return e !== ''
          })
          element.changedColumns = splittedArray;
        });
      }

    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format('MMM DD, YYYY hh:mm a')
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    viewPublicYN(public_yn) {
      if (public_yn === 'Y') {
        return 'Published';
      } else if (public_yn === 'N') {
        return 'Draft';
      } else {
        return public_yn;
      }
    },
    viewActiveYn(active_yn) {
      if (active_yn === 'Y') {
        return 'Reverted';
      } else if (active_yn === 'N') {
        return 'Moved to Trash';
      } else {
        return active_yn;
      }
    },
    prettifyTitle(title) {
      var responseTitle = title;
      switch (title) {
        case 'title_en':
          responseTitle = 'Title (English)';
          break;
        case 'body_en':
          responseTitle = 'Content (English)';
          break;
        case 'body':
          responseTitle = 'Content';
          break;
        case 'public_yn':
          responseTitle = 'Publish Status';
          break;
        case 'active_yn':
          responseTitle = 'Delete Status';
          break;
        default:
          responseTitle = this.capitalizeFirstLetter(title);
      }
      return responseTitle;
    },
  },
}
</script>
